import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DeleteAgentSessionMutation,
  DeleteAgentSessionMutationVariables,
} from "./DeleteAgentSession.generated";

export const DELETE_AGENT_SESSION: TypedDocumentNode<
  DeleteAgentSessionMutation,
  DeleteAgentSessionMutationVariables
> = gql`
  mutation deleteAgentSession($agentSessionUuid: String!) {
    deleteAgentSession(agentSessionUuid: $agentSessionUuid) {
      ok
    }
  }
`;
